import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { MainPage } from './components/MainPage';
import { VisitorTracker } from './components/VisitorTracker';
import './styles/main.css';
const App = () => {
    return (_jsxs(_Fragment, { children: [_jsx(VisitorTracker, {}), _jsx(MainPage, {})] }));
};
export default App;
